// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";

export const isCdiSyncNowResult = objectOf({
  // Currently we expect an empty response from kirby
});
